import { connect } from 'react-redux';

import { closeTrainingRequiredModal } from '@/store/reducers/global/actions';
import { selectTrainingRequiredModalConfig } from '@/store/reducers/global/selectors';
import { AppState } from '@/types';

import { TrainingRequiredModal as Component } from './TrainingRequiredModal';

const mapStateToProps = (state: AppState) => ({
  config: selectTrainingRequiredModalConfig(state),
});

const mapActionsToProps = { closeTrainingRequiredModal };

export const TrainingRequiredModal = connect(mapStateToProps, mapActionsToProps)(Component);
